export default {
  groupName: 'target-retail',
  appName: 'Retail Category',
  baseRoute: '/dashboard/target-retail',
  label: 'Target - Retail Ad Effect Tracker Dashboard ',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'Target - Retail Ad Effect Tracker Dashboard '
};



// WEBPACK FOOTER //
// ./src/app/configuration/TargetRetail/config/main.js